import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { setShowUserGuideDummyData } from '../../../redux/reducers/rbacReducer';

export const teamsDriverObj = (dispatch, navigate) => {
  const driverObj = driver({
    allowClose: false,
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createTeam',
        popover: {
          title: 'Create New Team',
          description: 'Use this button to create a new team. You can define the team name, description, and type.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.updateTeamRole',
        popover: {
          title: 'Update Team Role',
          description: 'Click here to update the selected team role. You can also unassign the role from the team',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.teamUsers',
        popover: {
          title: 'Team Users',
          description:
            'Click here to view the users in the team. In this section you can also add and remove users from the team',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.editTeam',
        popover: {
          title: 'Edit Team',
          description: 'Click here to edit the selected team. You can update the team name and description here.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.deleteTeam',
        popover: {
          title: 'Delete Team',
          description:
            'Use this button to delete the selected team. Be cautious, as this action is irreversible and will remove the team.',
          side: 'top',
          align: 'end',
          onNextClick: () => {
            dispatch(setShowUserGuideDummyData(false));
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default teamsDriverObj;
